import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSGrupoEstoqueClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/grupo-estoque');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Grupo Estoque');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/grupo-estoque', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Grupo Estoque');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/grupo-estoque', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Grupo Estoque');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/grupo-estoque/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Grupo Estoque');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/grupo-estoque/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Grupo Estoque');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/grupo-estoque/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Grupo Estoque');
    }
  }
}
